module.exports = __webpack_public_path__ + "images/marker-eten.c0f227.png";